export default "__VITE_ASSET__CqjG8s$p__"